export default __webpack_public_path__ + "static/media/google_fit.f54380af.png";